export default "__VITE_ASSET__D1RAfj2l__"